import axios from 'axios';
import { getDeviceId } from '../utils/device-info.util';
import { getLocalValue } from '../utils/local-cache.util';
import { LS_ADMIN_USER_AUTH_TOKEN } from '../config/const.config';

const prepareRequestOptions = (url, method, data = null) => {
  const baseAPIUrl = process.env.REACT_APP_CMS_API_ENDPOINT;
  const uuid = getDeviceId();
  const adminAuth = getLocalValue(LS_ADMIN_USER_AUTH_TOKEN);

  const options = {
    url: `${baseAPIUrl}${url}`,
    method,
    headers: {
      'Content-Type': 'application/json',
      'X-Req-Device': uuid,
      'X-Admin-Auth-Token': adminAuth,
    },
    data: JSON.stringify(data || {}),
  };

  return options;
};


export const createNewSeries = async (payload) => {
    const options = prepareRequestOptions(
      '/admin/series/create',
      'POST',
      payload
    );
  
    const response = await axios(options);
    return response.data;
  };
  
  export const viewSeriesById = async (id) => {
    const options = prepareRequestOptions(`/admin/series/${id}/view`, 'GET');
  
    const response = await axios(options);
    return response.data;
  };
  
  export const updateSeriesById = async (id, payload) => {
    const options = prepareRequestOptions(
      `/admin/series/${id}/update`,
      'POST',
      payload
    );
  
    const response = await axios(options);
    return response.data;
  };
  
  export const deleteSeriesById = async (id) => {
    const options = prepareRequestOptions(`/admin/series/${id}/delete`, 'DELETE', null,  true);
  
    const response = await axios(options);
    return response.data;
  };

  export const createNewSeason = async (payload) => {
    const options = prepareRequestOptions(
      '/admin/seasons/create',
      'POST',
      payload
    );
  
    const response = await axios(options);
    return response.data;
  };
  
  export const viewSeasonById = async (id) => {
    const options = prepareRequestOptions(`/admin/seasons/${id}/view`, 'GET');
  
    const response = await axios(options);
    return response.data;
  };
  
  export const updateSeasonById = async (id, payload) => {
    const options = prepareRequestOptions(
      `/admin/seasons/${id}/update`,
      'POST',
      payload
    );
  
    const response = await axios(options);
    return response.data;
  };
  
  export const deleteSeasonById = async (id) => {
    const options = prepareRequestOptions(
      `/admin/seasons/${id}/delete`,
      'DELETE',
      null,
      true
    );
  
    const response = await axios(options);
    return response.data;
  };

  export const updateSeasonEpisodesSequence = async (payload) => {
    const options = prepareRequestOptions(
      '/admin/sequence/episodes/update',
      'POST',
      payload
    );
  
    const response = await axios(options);
    return response.data;
  };

  export const updateSeasonSequence = async (payload) => {
    const options = prepareRequestOptions(
      '/admin/sequence/seasons/update',
      'POST',
      payload
    );
  
    const response = await axios(options);
    return response.data;
  };

  export const getSearchListSeries = async (adminUserId) => {
    const options = prepareRequestOptions(
      `/admin/series/search-list/${adminUserId}`,
      'GET'
    );
  
    const response = await axios(options);
    return response.data;
  };

  export const getSearchListSeasons = async (seriesId) => {
    const options = prepareRequestOptions(
      `/admin/seasons/search-list/${seriesId}`,
      'GET'
    );
  
    const response = await axios(options);
    return response.data;
  };
  